export { default } from "ember-truth-helpers/helpers/and";
